import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FileUtilsService {
  constructor() {}

  downloadFile<T>(data: T[], filename = 'data', headerList: string[]) {
    const csvData = this.convertToCSV(data, headerList);
    const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const dwldLink = document.createElement('a');
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', `${filename}.csv`);

    const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;

    if (isSafari) {
      dwldLink.setAttribute('target', '_blank');
    }

    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  convertToCSV<T>(objArray: T[], headerList: string[]) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    const mappedData = [headerList, ...array.map((item: any) => Object.values(item))];

    return mappedData.map((row) => row.join(',')).join('\n');
  }

  parseCsvToJson<T>(file: File, delimiter = ','): Promise<T[]> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        const text = event.target?.result as string;
        if (!text) return reject('File kosong');

        const lines = text
          .split('\n')
          .map((line) => line.trim())
          .filter((line) => line !== '');

        if (lines.length < 2) {
          return reject('');
        }

        const headers = lines[0].split(delimiter).map((h) => h.trim()) as (keyof T)[];
        const result: T[] = [];

        for (let i = 1; i < lines.length; i++) {
          const obj = {} as T;
          const values = lines[i].split(delimiter).map((v) => v.trim());

          headers.forEach((header, index) => {
            const raw = values[index];
            const value = raw === undefined ? null : isNaN(Number(raw)) ? raw : Number(raw);
            (obj as any)[header] = value;
          });

          result.push(obj);
        }

        resolve(result);
      };

      reader.onerror = () => reject('can`t read the document');
      reader.readAsText(file);
    });
  }
}
